import type { MiddlewareAPI } from 'redux';
import type { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { isNewReport } from '../../common/utils';
import type { Report } from '../../model/types';
import { getReportsForBoard } from '../../rest/reports-list';
import { getBoardId, getBaseUrl, getProjectKey } from '../../state/selectors/base';
import type { State } from '../../state/types';

const getPrettyReportUrl = (
	baseUrl: string,
	projectKey: string,
	boardId: number,
	urlName: string,
) => {
	if (urlName === 'burndown') {
		return `${baseUrl}/jira/software/projects/${projectKey}/boards/${boardId}/reports/${urlName}?source=overview`;
	}

	return `${baseUrl}/jira/software/projects/${projectKey}/boards/${boardId}/reports/${urlName}`;
};

export const getReportList = (store: MiddlewareAPI<State>): Observable<Report[]> => {
	const state = store.getState();
	const boardId = getBoardId(state);
	const baseUrl = getBaseUrl(state);
	const result = getReportsForBoard(baseUrl, boardId);
	return result.map((reports) =>
		reports.map(
			({
				key,
				group,
				name,
				description,
				urlName,
				imageUri,
				isApplicable,
				inapplicableReason,
				inapplicableDescription,
			}) => {
				const url = getPrettyReportUrl(baseUrl, getProjectKey(state), boardId, urlName);
				const transformed: Report = {
					reportKey: key,
					group,
					name,
					description,
					url,
					isNew: isNewReport(key),
					imageUri,
					isApplicable,
				};
				if (inapplicableReason && inapplicableDescription) {
					transformed.inapplicableReason = {
						reason: inapplicableReason,
						description: inapplicableDescription,
					};
				}
				return transformed;
			},
		),
	);
};
